var map = {
	"./de.json": 855998,
	"./en.json": 191071,
	"./es.json": 127145,
	"./fr.json": 408534,
	"./it.json": 883978,
	"./ja.json": 850225,
	"./ko.json": 632003,
	"./pl.json": 298661,
	"./pt.json": 693610,
	"./ru.json": 907962,
	"./uk.json": 752198
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 934940;